import { memo } from 'react';

import TagType from 'types/Tag';
import Tag from '@templates/Tag';
import ActionsOnTop from '@components/ActionsOnTop/index';

import classes from './BarAboveTitle.module.scss';

type Props = {
  id: number;
  productTypeId: number;
  tags?: TagType[];
  isFavorite?: boolean;
  onAddToFavorite?: () => void;
};

const BarAboveTitle = ({
  id,
  productTypeId,
  tags = [],
  isFavorite = false,
  onAddToFavorite = () => {},
}: Props): JSX.Element => (
  <div className={classes.wrapper}>
    <div className={classes.tags}>
      {tags.map((tag) => (
        <div key={tag.id} className={classes.tag}>
          <Tag url={tag.url}>{tag.name}</Tag>
        </div>
      ))}
    </div>
    <ActionsOnTop id={id} productTypeId={productTypeId} isFavorite={isFavorite} onFavorite={onAddToFavorite} />
  </div>
);

export default memo(BarAboveTitle);
